import React from "react"
import { HomePanelsWrapper } from "./HomePanels.styles"
import { graphql, useStaticQuery } from "gatsby"
import { prefixStatamicAssetUrl } from "../../../utils/statamicAssets"

/**
 * @returns {{
 *   panelsTitle: string | null,
 *   panels: {
 *     title: string,
 *     subHeading: string,
 *     icon: {
 *       fixed: {
 *         src: string,
 *         width: number,
 *         height: number
 *       },
 *       title: string
 *    }
 *    url: string | null
 *  }[]
 * }|null}
 */
function useHomePanels(){
  const query = useStaticQuery(graphql`
    query HomePanelsQuery {
      statamic {
        entries(collection: "home", limit: 1) {
          data {
            ... on Statamic_Entry_Home_Home {
              panels_title
              panels {
                title
                sub_heading
                url
                icon {
                  url
                  permalink
                  ... on Statamic_Asset_Assets {
                    alt
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const node = query?.statamic?.entries?.data?.[0]
  if(!node) return null
  if(!node.panels?.length) return null

  return {
    panelsTitle: node.panels_title || null,
    panels: node.panels.map(panel => {
      const icon = panel.icon
      const iconSrc = icon && (icon.permalink || icon.url)
        ? `${prefixStatamicAssetUrl(icon.permalink || icon.url)}?w=120`
        : null
      const width = 120
      const height = icon && icon.width && icon.height
        ? Math.round(icon.height * (width / icon.width))
        : undefined
      return {
        title: panel.title,
        subHeading: panel.sub_heading || "",
        url: panel.url || null,
        icon: iconSrc ? {
          fixed: { src: iconSrc, width, height },
          title: (icon && icon.alt) || "",
        } : null,
      }
    }),
  }
}

export default function(){

  const home = useHomePanels()
  if(!home) return null

  return (
      <HomePanelsWrapper className="px-3">
        <div className="container">
          {home.panelsTitle && <h2>{home.panelsTitle}</h2>}

          <div className="panels">

            {home.panels.map((panel, index) => (
                <article key={index} className="panel">
                  {panel.icon && <div className="icon">
                    <img src={panel.icon.fixed.src} alt={panel.icon.title} width={panel.icon.fixed.width}
                         height={panel.icon.fixed.height} />
                  </div>}
                  <h3>
                    {panel.url ? <a href={panel.url}>{panel.title}</a> : panel.title}
                  </h3>
                  <p>{panel.subHeading}</p>
                </article>
            ))}

          </div>

        </div>
      </HomePanelsWrapper>
  )
}
